var chunkMapping = {
	"8517": [
		308517
	],
	"16666": [
		29529
	],
	"19252": [
		619252
	],
	"22815": [
		322815
	],
	"29529": [
		29529
	],
	"32148": [
		569069
	],
	"41528": [
		551977,
		101614
	],
	"43039": [
		404657,
		894713,
		227054,
		836534
	],
	"43944": [
		543944
	],
	"54871": [
		654871
	],
	"67624": [
		564011,
		956443
	],
	"69069": [
		569069
	],
	"70783": [
		818768,
		545819,
		39077,
		694249,
		954457,
		895332
	],
	"71132": [
		971132
	],
	"73165": [
		873165
	],
	"75619": [
		475619
	],
	"95919": [
		895919
	],
	"99648": [
		899648
	]
};
var idToExternalAndNameMapping = {
	"29529": [
		"default",
		"./components/TeachingCard",
		681207
	],
	"39077": [
		"default",
		"./components/GradingRubric",
		681207
	],
	"101614": [
		"default",
		"./components/Presentation",
		681207
	],
	"227054": [
		"default",
		"./utils/html-doc",
		681207
	],
	"308517": [
		"default",
		"./components/Icon/FocusIcon",
		681207
	],
	"322815": [
		"default",
		"./components/HelpCenter",
		681207
	],
	"404657": [
		"default",
		"./components/HtmlWithPinyin",
		681207
	],
	"475619": [
		"default",
		"./components/Question",
		681207
	],
	"543944": [
		"default",
		"./components/UserProfileAvatar",
		681207
	],
	"545819": [
		"default",
		"./components/FullscreenContainer",
		681207
	],
	"551977": [
		"default",
		"./components/NewFlashcard",
		681207
	],
	"564011": [
		"default",
		"./components/Game",
		681207
	],
	"569069": [
		"default",
		"./components/CoreItemsIWGT",
		681207
	],
	"619252": [
		"default",
		"./hooks/dictionary",
		681207
	],
	"654871": [
		"default",
		"./components/UserAvatar",
		681207
	],
	"694249": [
		"default",
		"./components/WritingFeedback/FeedbackSection",
		681207
	],
	"818768": [
		"default",
		"./components/EvaluationForm",
		681207
	],
	"836534": [
		"default",
		"./utils/pinyin",
		681207
	],
	"873165": [
		"default",
		"./avatar/constants",
		681207
	],
	"894713": [
		"default",
		"./hooks/use-resize",
		681207
	],
	"895332": [
		"default",
		"./components/WritingFeedback/hooks/use-writing-feedback",
		681207
	],
	"895919": [
		"default",
		"./components/Quiz",
		681207
	],
	"899648": [
		"default",
		"./components/AudioPlayer",
		681207
	],
	"954457": [
		"default",
		"./components/WritingFeedback/WritingQuestionSection",
		681207
	],
	"956443": [
		"default",
		"./utils/route-change-prompt",
		681207
	],
	"971132": [
		"default",
		"./components/Playbook",
		681207
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}